import React, { ReactNode, useCallback } from "react";
import { connect } from "react-redux";

import Select, { SelectProps } from "antd/es/select";
import { useIntl } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import { getActivityTypes } from "@app/store/activity";
import { RootState } from "@app/store/rootReducer";
import useActivityTypeOptions from "@app/util/ui/useActivityTypeOptions";

interface Props extends Omit<SelectProps<ActivityType["id"]>, "onChange" | "value"> {
  activityTypes: ActivityType[];
  onChange?: (value: ActivityType["id"]) => void;
  placeholder?: ReactNode;
  value?: ActivityType["id"];
}

const SelectActivityTypeField: React.FC<Props> = ({
  activityTypes,
  onChange,
  placeholder,
  value,
  ...props
}) => {
  const intl = useIntl();
  const activityTypeOptions = useActivityTypeOptions(
    activityTypes,
    value,
    useCallback((type) => !type.active, [])
  );

  return (
    <Select<ActivityType["id"]>
      dropdownMatchSelectWidth={false}
      filterOption={(inputValue, option) =>
        option?.text.toLowerCase().includes(inputValue.toLowerCase().trim()) ?? false
      }
      onChange={onChange}
      options={activityTypeOptions}
      placeholder={
        placeholder ??
        intl.formatMessage({
          id: "activityTypeSelectField.placeholder",
          defaultMessage: "Select",
          description: "Placeholder for the Activity Type field",
        })
      }
      showSearch
      value={value}
      {...props}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  activityTypes: getActivityTypes(state),
});

export default connect(mapStateToProps, {})(SelectActivityTypeField);
